import React, { Component } from 'react';
import './Menu.css';
import './IconButton.css';
import './Filters.css';
import MenuType from '../enums/MenuType';
import IconButton from './IconButton';
import HashSource from '../core/HashSource';
import UnitMarkerKey from './UnitMarkerKey';
import ClickedOffManager from '../ui_core/ClickedOffManager';
import SubMenuHeader from './SubMenuHeader';
import FiltersButtons from './FiltersButtons';
import Urls from '../urls/Urls';
import AssetsManager from  '../assets_management/AssetsManager';//
export default class Filters extends Component {
	constructor(props){
		super(props);
		const {clickClear, clickShowForSale, getConfiguration} = props;
		this._uniqueKey=0;
		this._nextKey = ()=>String(this._uniqueKey++);
		this._getConfiguration = getConfiguration;
		this._clickClear = clickClear;
		this._clickShowForSale = clickShowForSale;
		this._subMenuHeader = React.createRef();
		this._element = React.createRef();
		this._unitMarkerKeyRef = React.createRef();
		this._iMenuManager  = null;
		this.load = this.load.bind(this);
		this.show = this.show.bind(this);
		this.hide= this.hide.bind(this);
		this._clickedOffManager = new ClickedOffManager({elementRef:this._element, hide:this.hide});
		this._filtersButtonsRef = React.createRef();
		this.state = {visible:false, siteJson:null};
	}
	load({siteJson}){
		this.setState({siteJson});
		this._filtersButtonsRef.current.load({siteJson});
		this._unitMarkerKeyRef.current?.load({siteJson});
	}
	show(){
		this._filtersButtonsRef.current&&(this._filtersButtonsRef.current.isShowing = true);
		this.setState({visible:true});
		this._clickedOffManager.register();
		this._iMenuManager.showMe(this);
	}
	hide(){
		this._filtersButtonsRef.current&&(this._filtersButtonsRef.current.isShowing = false);
		this._clickedOffManager.dispose();
		this.setState({visible:false});
		this._iMenuManager.close();
	}	
	setIMenuManager(value){
		this._iMenuManager = value;
		this._filtersButtonsRef.current.setIMenuManager(value);
		this._subMenuHeader.current.setIMenuManager(value);
	}
	get menuType(){
		return MenuType.FILTERS;
	}
	render() {
		const configuration = this._getConfiguration();
		this._uniqueKey=0
		let className = "filters menu";
		if(this.state.visible)
			className+=" visible";
		let title = null;
		if(configuration.unitMarkerKeyAtTop){
			const unitMarkerKey = (<UnitMarkerKey ref={this._unitMarkerKeyRef} hasKeyHeading={
				!configuration.unitMarkerKeyAtTop} key={this._nextKey()}></UnitMarkerKey>);
			title = unitMarkerKey;
		}
		let bottomUnitMarkerKey = null;
		if(!configuration.unitMarkerKeyAtTop){
			bottomUnitMarkerKey = (<UnitMarkerKey ref={this._unitMarkerKeyRef} hasKeyHeading={
				!configuration.unitMarkerKeyAtTop} key={this._nextKey()}></UnitMarkerKey>);
		}
		return (<div className={className} ref={this._element}>
				<SubMenuHeader ref={this._subMenuHeader}>{title}</SubMenuHeader>
				<FiltersButtons ref={this._filtersButtonsRef} getConfiguration={this._getConfiguration }
					clickClear={this._clickClear} clickShowForSale={this._clickShowForSale} nextKey={this._nextKey}>
				</FiltersButtons>
				{bottomUnitMarkerKey}
			</div>)
	}
}